import { Component } from 'react'
import PropTypes from 'prop-types'

class StoreBlock extends Component {
  render() {
    const { title, image, classes } = this.props
    return (
      <div className={`ctp-store-block ${classes || ''}`}>
        <div className="ctp-store-block__inner">
          <div className="ctp-store-block__media">
            <img src={image} />
          </div>
          <h2>{title}</h2>
        </div>
      </div>
    )
  }
}

StoreBlock.propTypes = {
  classes: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string.isRequired,
}

export default StoreBlock
